import { css } from 'lit';

import { touchOrNarrow } from '../media.js';

export const planeHelpStyles = css`
  :host {
    display: inline-flex;
    vertical-align: middle;
  }

  .anchor {
    position: relative;
    display: inline-flex;
  }

  /* A small round mark, quieter than the title it follows. */
  button {
    display: inline-grid;
    place-items: center;
    width: 1.5rem;
    height: 1.5rem;
    padding: 0;
    border: var(--border-width) solid var(--border-strong);
    border-radius: var(--radius-round);
    background: var(--surface);
    color: var(--text-muted);
    font-family: var(--font-mono);
    font-size: var(--font-size-xs);
    font-weight: var(--font-weight-semibold);
    line-height: var(--line-height-none);
    cursor: pointer;
  }

  @media ${touchOrNarrow} {
    button {
      width: var(--touch-target-compact);
      height: var(--touch-target-compact);
    }
  }

  button:hover,
  :host([open]) button {
    border-color: var(--accent);
    color: var(--accent);
  }

  button:focus-visible {
    outline: var(--focus-ring);
    outline-offset: var(--focus-ring-offset);
  }

  /* The title's type stops here: the explanation reads as body text. */
  .panel {
    position: absolute;
    top: calc(100% + var(--space-2));
    left: 0;
    z-index: var(--z-overlay);
    width: min(var(--prose-width), calc(100vw - 2rem));
    padding: var(--space-4) var(--space-5);
    border: var(--border-width) solid var(--border);
    border-radius: var(--radius);
    background: var(--surface-raised);
    box-shadow: var(--shadow-float);
    color: var(--text);
    font-family: var(--font-sans);
    font-size: var(--font-size-sm);
    font-weight: var(--font-weight-normal);
    letter-spacing: normal;
    line-height: var(--line-height-body);
    text-transform: none;
  }

  .panel[hidden] {
    display: none;
  }

  ::slotted(p) {
    margin: 0 0 var(--space-2);
  }

  ::slotted(p:last-child) {
    margin-bottom: 0;
  }
`;
